import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageShell } from './layout';
import UserSettings from './UserSettings';
import styles from '../styles/AccountPage.module.css';

const AccountPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Go back in history if possible, otherwise go home
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <PageShell onBack={handleBack}>
      <div className={styles.accountContainer}>
        <UserSettings />
      </div>
    </PageShell>
  );
};

export default AccountPage;

